import { safeJsonParse } from '@commonClient2/services/json';
import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT } from './auth.actions';

const user = safeJsonParse(localStorage.getItem('user'));

const initialState = user
    ? { isLoggedIn: true, user }
    : { isLoggedIn: false, user: null };

/**
 *
 * @param {*} state
 * @param {{ type: string, payload: any }} action
 * @returns
 */
// eslint-disable-next-line default-param-last
export default function authReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: payload.user,
            };
        case LOGIN_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        case LOGOUT:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            return state;
    }
}
